import { LogErrors } from './../LogErrors'

import { DoubleAttempt } from './Helpers/DoubleAttempt'


/**
 * 
 * @param {string} user 
 * @param {string} password 
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const Login = async (user, password) => {
    try {
        const dataToSend = {
            username: user,
            password: password
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
        }
        
        const url = process.env.REACT_APP_API_URL + "/api/Api/login"
        
        const response = await DoubleAttempt(url, parameters)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/Api/login", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify(dataToSend)
        // })

        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message }
        // }
        
        // const data = await response.json()
    
        // // Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        //return { success: false, message: error || 'Error al conectar con el servidor' }
        await LogErrors('Login - Sessions DL', error)
        //return { success: false, message: 'errorNetwork' } // Código genérico para errores de red
        return { success: false, message: 2 }
    }
}

/**
 * @param {string} token
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const Logout = async (token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }

        const url = process.env.REACT_APP_API_URL + "/api/Api/closeSession"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/Api/closeSession", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     }
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // // Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('Logout - Sessions DL', error)
        return { success: false, message: 'No ha sido posible cerrar tu sesión. Inténtalo nuevamente o inténtalo más tarde' }
    }
}

/**
 * Función que valida si la sesión sigue activa
 * @param {string} token
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const ValidateSession = async (token) => {
    try {
        // const parameters = {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     }
        // }

        // const url = process.env.REACT_APP_API_URL + "/api/Api/ValidateSession"

        // const response = await DoubleAttempt(url, parameters, false)

        // if (response.success) {
        //     return { success: true, data: response.data }
        // } else {
        //     return { success: false, message: response.message }
        // }

        // // const response = await fetch(process.env.REACT_APP_API_URL + "/api/Api/ValidateSession", {
        // //     method: 'POST',
        // //     headers: {
        // //         'Content-Type': 'application/json',
        // //         'Authorization': token
        // //     }
        // // })
        
        // // if (!response.ok) {
        // //     // Manejar errores HTTP
        // //     const errorData = await response.json()
        // //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        // //     return { success: false, message: errorData.message } //errorCode
        // // }
        
        // // Retornar la respuesta exitosa
        return { success: true, data: {} }
    } catch (error) {
        await LogErrors('ValidateSession - Session DL', error)
        return { success: false, message: '' }
    }
}

/**
 * @param {Array} sessionInfo 
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const UpdateSessionInfo = async (sessionInfo) => {
    try {
        await sessionStorage.setItem('userData', JSON.stringify(sessionInfo))

        return { success: true, data: sessionInfo }
    } catch (error) {
        await LogErrors('UpdateSessionInfo - Session DL', error)
        return { success: false, message: '' }
    }
}

const DeleteSessionInfo = async () => {
    try {
        sessionStorage.removeItem('userData')
        sessionStorage.removeItem('settings')

        return { success: true }
    } catch (error) {
        await LogErrors('DeleteSessionInfo - Session DL', error)
        return { success: false, message: '' }
    }
}

export { Login, Logout, ValidateSession, UpdateSessionInfo, DeleteSessionInfo };